import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputLabel from "@mui/material/InputLabel";
import { Icon } from "@iconify/react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Spinner from "react-bootstrap/Spinner";
import Link from "@mui/material/Link";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import { Multiselect } from "multiselect-react-dropdown";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Button, IconButton } from "@mui/material";
import settings from "../helpers/Settings";
import * as moment from "moment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Cookies from "js-cookie";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import Form from "react-bootstrap/Form";

let { KayanURL } = settings;
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};

/**  procedure["price"] = codeInfo["price"];
            procedure["discount"] = codeInfo["discount"];
            procedure["priceAfterDiscount"] = codeInfo["price_after_discount"];
            procedure["tax"] = codeInfo["tax"];
            procedure["Net"] = codeInfo["Net"];
            procedure["date"] = "2023-12-06";
            console.log("new procedure", procedure); */

const demoProcedures = {
  1004: {
    priceAfterDiscount: 200,
    tax: 30,
    Net: 230,
    date: "2023-12-11",

    price: 200,
    discount: 0,
    patientshare_total: 0,
    tax_percentage: 0,
    package: false,
  } /* ,
  515: {
    discount: 0,
    price: 300,
    priceAfterDiscount: 300,
    tax: 45,
    Net: 345,
    date: "2023-12-11",
  },
  618: {
    discount: 0,
    price: 1300,
    priceAfterDiscount: 1300,
    tax: 195,
    Net: 1495,
    date: "2023-12-11",
  }, */,
};

class vitalSigns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addDiagnosis: false,
      addProcedure: false,
      oralSlected: false,
      allDiagnosis: [],
      procedures: [],
      diagnosisSequence: [],
      informationSequence: [],
      vitalSignsArray: [],
      supportingInfoarray: [],
      elegibilityOffline: false,
      elegibilityOnline: false,
      proceduresForNeedApproval: [],
      vitalSignSelectArray: [],
      allDiagnosisSelect: [],
      defaultValueClaimFlag: false,
      defaultValuePayerIDFlag: false,
      addBatch: false,
      createRequestModal: false,
      updateClaim: false,
      tabsValue: "1",
      calimDefaultValue: "",
      diagnosisType: "",
      procedureCode: "",
      procedureQuantity: "",
      procedureShare: "",
      procedureDescription: "",
      procedureStatus: "",
      procedureTax: "",
      procedurePrice: "",
      vitalSelect: "",
      vitalValue: "",
      autoCompleteValue: false,
      serviceValue: "",
      toothNumberValue: "",
    };
  }

  componentDidMount = async () => {
    let currentdate = new Date();
    let date = moment(currentdate).format("YYYY-MM-DD");
    this.setState({ inputDate: date });
    this.getAllDoctors();

  };
  getAllVisits = async (date, id) => {
    let allVisits = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getAllVisits",
      {
        data: {
          dateofvisit: date,
          doctorID: id
        },
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (allVisits) {
      let { data } = allVisits;
      console.log(data, "visits");
      if (data) {
        if (data.success) {
          console.log(data);
          this.setState({ success: true, allVisits: data.visits });
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };









  handlePatientSelect = (e) => {
    e.preventDefault();
    this.setState({
      selectedPatient: {},
      Msg:"",
      selectedId: e.target.attributes.value.value,
    });

    let {
      allVisits,
      vitalSignsArray,
      supportingInfoarray
    } = this.state;
    const year = new Date().getFullYear();
    let selectedPatient = allVisits.filter((element) => {
      return e.target.attributes.value.value == element.id;
    });
    // console.log(selectedPatient, 'herrrrrrrrrr')
    if (selectedPatient && selectedPatient.length > 0) {

      const dateSplit = selectedPatient[0].birthdate.split("-");
      const birthYear = dateSplit[0];
      const age = year - birthYear + " years";
      let allVitalRows = [];
      let supportingInformationArray = []
      console.log(selectedPatient, 'selected')
      if (selectedPatient[0].supportinginformation == null) {
        supportingInformationArray.push({
          "reason-for-visit": selectedPatient[0].visittype,
        });


        selectedPatient[0].supportinginformation = supportingInformationArray;
      }
      if (
        selectedPatient[0].supportinginformation &&
        selectedPatient[0].supportinginformation.length > 0
      ) {
        console.log(selectedPatient[0].supportinginformation, 'supp')
        let categories = selectedPatient[0].supportinginformation;
        console.log(categories, 'categ')
        let vitalArray=[];
        for (let i = 0; i < categories.length; i++) {
          let display = Object.keys(categories[i]);
          let valueInfo = Object.values(categories[i]);
          if (display[0] === "chief-complaint") {
            valueInfo = Object.values(categories[i])[0].text;
          } else if (display[0] === "attachment") {
            valueInfo = Object.values(categories[i])[0].title;
          }

          vitalArray.push({ display: display[0], valueInfo: valueInfo[0] });
        }
        allVitalRows = selectedPatient[0].supportinginformation.map(
          (element, index) => {
            return (
              <TableRow key={index}>
                <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                  {Object.keys(element)}{" "}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                  {Object.keys(element)[0] === "chief-complaint"
                    ? Object.values(element)[0].text
                    : Object.keys(element)[0] === "attachment"
                      ? Object.values(element)[0].title
                      : Object.values(element)}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <IconButton
                    onClick={() => {
                      this.handleDeleteVital(index);
                    }}
                  >
                    <Icon color="red" icon="fluent:delete-12-regular" />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          }
        );
        this.setState({
          allVitalRows,
          addVitaltotable: true,
          supportingInfoarray: selectedPatient[0].supportinginformation,
          vitalSignsArray: vitalArray

        });
      } else {
        this.setState({
          vitalSignsArray: [],
          addVitaltotable: false,
          vitalSignJson: "",
        });
      }
      this.setState({

        selectedPatient,
        vitalSelected: false,
        age,
      });
    }
  };

  handleCloseVital = () => {
    this.setState({ vitalModal: false });
  };
  handleVitalSignModal = () => {
    this.setState({ vitalSignSelected: false, vitalModal: true });
  };

  handleDeleteVital = (index) => {
    let { vitalSignJson, vitalSignsArray, vitalSignSelectArray } = this.state;
    vitalSignsArray.splice(index, 1);
    vitalSignSelectArray.splice(index, 1);
    const allVitalRows = vitalSignsArray.map((element, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
            {element.display}{" "}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
            {element.valueInfo}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            <IconButton
              onClick={() => {
                this.handleDeleteVital(index);
              }}
            >
              <Icon color="red" icon="fluent:delete-12-regular" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    });
    this.setState({ allVitalRows });
    if (JSON.stringify(vitalSignJson) == "[]") {
      this.setState({ addVitaltotable: false });
    }
  };

  HandleInputTextChange = (e) => {
    // let name = e.target.name;
    let value = e.target.value;
    let { inputDate } = this.state
    this.getAllVisits(inputDate, value)
    // let {allDoctors} = this.state
    // let selectedDoctor = allDoctors.filter((p) => {
    //   return p.id == value;
    // });
  };
  HandleVitalSignChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ vitalSelect: value });
    if (value) {
      name = value;
      this.setState({ vitalSignSelected: true, selectedName: value });
      if (value === "chief-complaint") {
        this.setState({
          chiefComplainSelected: true
        })
      } else {
        this.setState({
          chiefComplainSelected: false
        })
      }
    } else {
      this.setState({ vitalSignSelected: false });
    }
  };
  handleCheckBoxChange = (e) => {
    if (e.target.name == "online") {
      if (e.target.checked) {
        this.setState({ elegibilityOnline: true });
      } else {
        this.setState({ elegibilityOnline: false });
      }
    } else if (e.target.name == "offline") {
      if (e.target.checked) {
        this.setState({ elegibilityOffline: true });
      } else {
        this.setState({ elegibilityOffline: false });
      }
    }
  };
  HandleSupportingInfoChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { selectedName } = this.state;
    if (selectedName === "chief-complaint") {
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo: { text: value } },
        vitalValue: value,
      });
    } else {
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo: value },
        vitalValue: value,
      });
    }
  };
  handleConfirm = async (e) => {
    e.preventDefault();

    let {
      supportingInfoarray,
      vitalSignsArray,
      vitalSignJson,
    } = this.state;
    this.setState({ vitalSelect: "", vitalValue: "" });
    supportingInfoarray.push({
      [vitalSignJson.display]: vitalSignJson.valueInfo,
    });
    vitalSignsArray.push(vitalSignJson);
    console.log(supportingInfoarray, "suporting");
    console.log(vitalSignsArray, "vital");
    const allVitalRows = vitalSignsArray.map((element, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
            {element.display}{" "}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
            {element.valueInfo.name
              ? element.valueInfo.name
              : element.valueInfo.text
                ? element.valueInfo.text
                : element.valueInfo}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            <IconButton
              onClick={() => {
                this.handleDeleteVital(index);
              }}
            >
              <Icon color="red" icon="fluent:delete-12-regular" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    });
    this.setState({
      allVitalRows,
      addVitaltotable: true,
      vitalSignsArray,
    });

  };
  getAllDoctors = async () => {
    let AllDoctors = await axios.put(
      KayanURL + "api/KSA/RCM/employee/getAllDoctors",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        role: "doctor"
      }
    );
    if (AllDoctors) {
      console.log(AllDoctors, "doctors")
      let { data } = AllDoctors;
      if (data) {
        if (data.success) {
          this.setState({ success: true, allDoctors: data.doctors });
        } else {
          this.setState({
            success: false,
            error: data.error,
          });
        }
      }
    }
  };
  handleUpdateVisit = async (e) => {
    e.preventDefault();
    this.setState({Msg:""})
    let { selectedPatient, supportingInfoarray } = this.state
    let Response = await axios.put(
      KayanURL + "api/KSA/RCM/patient/updateVistSupportingInfo",
      {
        data: {
          id: selectedPatient[0].id,
          supportingInfo: JSON.stringify(supportingInfoarray),
        },
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      if (data) {
        if (data.success) {
          this.setState({
            success: true,
            Msg: "Vital Sign has been added successfully",
          });
          this.getAllVisits(this.state.inputDate);
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  }
  render() {
    let {
      allVisits,
      selectedPatient,
      allDoctors,
      supportingInfoarray,
      vitalSignsArray
    } = this.state;
    let doctorRows
    // console.log(supportingInfoarray,'hereeeeeee')
    // if (vitalSignsArray && vitalSignsArray.length > 0) {
    //   allVitalRows = vitalSignsArray.map((element, index) => {
    //     return (
    //       <TableRow key={index}>
    //         <TableCell align="center" style={{ fontSize: "small" }}>
    //           {element.display}{" "}
    //         </TableCell>
    //         <TableCell align="center" style={{ fontSize: "small" }}>
    //           {element.valueInfo.name
    //             ? element.valueInfo.name
    //             : element.valueInfo.text ? element.valueInfo.text : element.valueInfo}
    //         </TableCell>
    //         <TableCell align="center" style={{ fontSize: "small" }}>
    //           <IconButton
    //             onClick={() => {
    //               this.handleDeleteVital(index);
    //             }}
    //           >
    //             <Icon color="red" icon="fluent:delete-12-regular" />
    //           </IconButton>
    //         </TableCell>
    //       </TableRow>
    //     );
    //   });
    // }
    if (allDoctors && allDoctors.length > 0) {
      doctorRows = allDoctors.map((element, index) => {
        return (
          <option key={index} value={element.id} style={{ fontSize: "small" }}>
            {element.name}
          </option>
        );
      });
    }
    let patientsRows = []
    if (allVisits && allVisits.length > 0) {
      patientsRows = allVisits.map((element, index) => {
        if (!element.visitenddate) {
          let color;
          if (this.state.selectedId == element.id) {
            color = "lightgrey";
          } else {
            color = "unset";
          }
          return (
            <a key={index} onClick={this.handlePatientSelect}>
              <MenuItem
                sx={{ bgcolor: color }}
                value={element.id}
                style={{ fontSize: "small" }}
              >
                {element.firstname + " " + element.lastname}
              </MenuItem>
            </a>
          );
        }
      });
    }

    return (
      <div
        style={{
          textAlign: "left",
          margin: "auto",
          boxShadow: "1px solid grey",
          padding: "15px",
          boxShadow:
            "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
          /*           borderRadius: "10px", */
          marginTop: "50px",
          width: "100%",
        }}
      >
        <Row>
          <Col
            xs={2}
            style={{
              height: "620px",
              overflow: "scroll",
            }}
          >
            <Form.Group className="mb-3">
              <Typography style={{ fontSize: "15px", textAlign: "center", marginBottom: '10px' }}>
                Select a Doctor
              </Typography>
              <Form.Select
                onChange={this.HandleInputTextChange}
                required
                name="doctor"
              >
                <option value="0">select...</option>
                {doctorRows}
              </Form.Select>
            </Form.Group>
            <FormControl fullWidth sx={{ mb: 3 }}>
              <div style={{ width: "100%" }}>
                <Typography style={{ fontSize: "15px", textAlign: "center" }}>
                  All Visits
                </Typography>

                <ul
                  style={{
                    backgroundColor: "white",
                    listStyleType: "none",
                    textAlign: "left",
                    padding: "10px 0",
                    overflowY: "auto",
                    boxShadow:
                      "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                    height: "200px",
                    borderRadius: "10px",
                  }}
                >
                  {patientsRows}
                </ul>
              </div>
            </FormControl>
          </Col>

          <Col xs={10}>


            <hr />
            <Row>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].medicalfilenumber
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="medicalFile"
                    label="Medical File"
                    variant="outlined"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].gender
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="gender"
                    label="Gender"
                    variant="outlined"
                  />
                </FormControl>


              </Col>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].firstname +
                        " " +
                        selectedPatient[0].lastname
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="patient"
                    label="Patient Name"
                    variant="outlined"
                  />
                </FormControl>

                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].nationality
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="nationality"
                    label="Nationality"
                    variant="outlined"
                  />
                </FormControl>


              </Col>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].birthdate
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="birthDate"
                    label="Birth Date"
                    variant="outlined"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].visittype
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="visitType"
                    label="Visit Type"
                    variant="outlined"
                  />
                </FormControl>

              </Col>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? this.state.age
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="age"
                    label="Age"
                    variant="outlined"
                  />
                </FormControl>
                <>
                  {" "}
                  <FormControlLabel
                    aria-readonly
                    value="doctors"
                    checked={
                      selectedPatient &&
                        selectedPatient.length > 0 &&
                        selectedPatient[0].payment === "cash"
                        ? true
                        : false
                    }
                    control={<Radio />}
                    label="Cash"
                  />{" "}
                  <FormControlLabel
                    aria-readonly
                    value="doctors"
                    checked={
                      selectedPatient &&
                        selectedPatient.length > 0 &&
                        selectedPatient[0].payment === "insurance"
                        ? true
                        : false
                    }
                    control={<Radio />}
                    label="Insurance"
                  />
                </>
              </Col>
            </Row>

            <hr />
            <div style={{ textAlign: "center" }}>
              <Box sx={{ width: "100%" }}>

                <Link
                  style={{ padding: "20px" }}
                  sx={{
                    ml: 3,
                    color: "gray",
                    bgcolor: this.state.vitalSelected ? "lightgrey" : "unset",
                  }}
                  underline="none"
                  onClick={() => {
                    this.setState({
                      vitalSelected: true,
                    });
                  }}
                >
                  {"Vital Sign"}
                </Link>

              </Box>
            </div>

            <hr />
            <div style={{ textAlign: "center", width: "90%", margin: "auto" }}>
              {this.state.selectedPatient &&
                selectedPatient.length > 0 &&
                this.state.vitalSelected ? (
                <>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "rgb(97 110 120",
                        border: "1px ridge gray",
                        width: "2%",
                        boxShadow: "none",
                        height: "35px",
                      }}
                      onClick={this.handleVitalSignModal}
                    >
                      <AddIcon
                        style={{ paddingRight: "5px", color: "white" }}
                      />
                    </Button>
                  </div>

                  {this.state.allVitalRows && this.state.allVitalRows.length > 0 ? (
                    <>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "10px", width: "100%" }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Vital Sign</TableCell>
                              <TableCell align="center">Value</TableCell>
                              <TableCell align="center">Action</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>{this.state.allVitalRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                </>
              ) : null}

              {/****** **********************************/}

              {!selectedPatient &&
                (
                  this.state.vitalSelected) ? (
                <>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{ mt: 2 }}
                    style={{ textAlign: "center" }}
                  >
                    You need to select a patient
                  </Typography>
                </>
              ) : null}
              {this.state.vitalModal ? (
                <>
                  <Modal
                    open={this.state.vitalModal}
                    onClose={this.handleCloseVital}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ overflowY: "scroll" }}
                  >
                    <Box sx={styleModal} style={{ width: "30%" }}>
                      <div style={{ textAlign: "center" }}>
                        <FormControl style={{ width: "70%" }} sx={{ mb: 3 }}>
                          <InputLabel
                            id="category"
                            style={{ fontSize: "small" }}
                          >
                            Vital Sign
                          </InputLabel>
                          <Select
                            labelId="supportingInformation"
                            name="category"
                            label="supportingInformation"
                            onChange={this.HandleVitalSignChange}
                            value={this.state.vitalSelect}
                            style={{ height: "45px" }}
                          >
                            <MenuItem
                              value="vital-sign-diastolic"
                              style={{ fontSize: "small" }}
                            >
                              Diastolic
                            </MenuItem>
                            <MenuItem
                              value="vital-sign-systolic"
                              style={{ fontSize: "small" }}
                            >
                              Systolic
                            </MenuItem>
                            <MenuItem
                              value="vital-sign-height"
                              style={{ fontSize: "small" }}
                            >
                              Height
                            </MenuItem>
                            <MenuItem
                              value="vital-sign-weight"
                              style={{ fontSize: "small" }}
                            >
                              Weight
                            </MenuItem>
                            <MenuItem
                              value="birth-weight"
                              style={{ fontSize: "small" }}
                            >
                              Birth weight
                            </MenuItem>

                            <MenuItem
                              value="temperature"
                              style={{ fontSize: "small" }}
                            >
                              Temperature
                            </MenuItem>

                            <MenuItem
                              value="pulse"
                              style={{ fontSize: "small" }}
                            >
                              Pulse
                            </MenuItem>

                            <MenuItem
                              value="respiratory-rate"
                              style={{ fontSize: "small" }}
                            >
                              Respiratory Rate
                            </MenuItem>

                            <MenuItem
                              value="chief-complaint"
                              style={{ fontSize: "small" }}
                            >
                              Chief Complaint
                            </MenuItem>
                            {/* <MenuItem
                              value="attachment"
                              style={{ fontSize: "small" }}
                            >
                              Attachment
                            </MenuItem> */}
                          </Select>
                        </FormControl>
                      </div>

                      {this.state.chiefComplainSelected ? (
                        <>
                          <div style={{ textAlign: "center" }}>
                            <FormControl
                              style={{ width: "70%" }}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                InputLabelProps={{
                                  sx: { fontSize: "small" },
                                }}
                                value={this.state.vitalValue}
                                inputProps={{ sx: { padding: "11px" } }}
                                required
                                type="text"
                                name={this.state.selectedName}
                                label={this.state.selectedName}
                                variant="outlined"
                                onChange={this.HandleSupportingInfoChange}
                              />
                            </FormControl>
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                width: "100px",
                              }}
                              onClick={(e) => this.handleConfirm(e)}
                            >
                              Add
                            </Button>
                          </div>
                        </>
                      ) : this.state.vitalSignSelected ? (
                        <>
                          <div style={{ textAlign: "center" }}>
                            <FormControl
                              style={{ width: "70%" }}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                InputLabelProps={{
                                  sx: { fontSize: "small" },
                                }}
                                value={this.state.vitalValue}
                                inputProps={{ sx: { padding: "11px" } }}
                                required
                                type="number"
                                name={this.state.selectedName}
                                label={this.state.selectedName}
                                variant="outlined"
                                onChange={this.HandleSupportingInfoChange}
                              />
                            </FormControl>
                          </div>

                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                width: "100px",
                              }}
                              onClick={(e) => this.handleConfirm(e)}
                            >
                              Add
                            </Button>
                          </div>
                        </>
                      ) : null}
                    </Box>
                  </Modal>
                </>
              ) : null}
              <div style={{ textAlign: "center" }}>

                <Button
                  variant="primary"
                  type="submit"
                  onClick={(e) => this.handleUpdateVisit(e)}
                  style={{
                    width: "20%",
                    marginTop: "32px",
                    backgroundColor: "rgb(97 110 120",
                    border: "1px solid rgb(97 110 120",
                    color: "white"
                  }}
                >
                  Add Vitals
                </Button>
              </div>
              {this.state.success ? (<>
                <Typography style={{ textAlign: "center", color: "green" }}>
                  {this.state.Msg}
                </Typography>
              </>) : null}
              {this.state.errMsg ? (
                <>
                  <Typography style={{ textAlign: "center", color: "red" }}>
                    {this.state.errMsg}
                  </Typography>
                </>
              ) : null}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default vitalSigns;
